<template>
    <DModal
        v-model="form.activity_log_comment"
        :show="showModal"
        :title="__('tools.invoices.set_debt_loss_modal.title')"
        :message="__('tools.invoices.set_debt_loss_modal.message')"
        is-confirm
        :show-change-reason-input="true"
        :is-awaiting-validation="true"
        @close="closeModal()"
        @confirm="save"
    />
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    invoice: {
        type: Object,
        default: () => { return {} }
    }
})

const errors = ref({})

const form = useForm({
    activity_log_comment: null
})

const emit = defineEmits(['close-modal'])

function closeModal () {
    emit('close-modal')
}

function save () {
    form.post(route('tools.invoices.set-debt-loss', { invoice: props.invoice.id }), {
        onSuccess: () => {
            emit('close-modal')
        },
        onError: (error) => {
            errors.value = error
        }
    })
}

</script>
